import React from "react";
import { useNavigate } from "react-router-dom";
import ProjectCard from "../../components/ProjectCard/ProjectCard";
import "./Home.css";

// Importar imágenes
import HomeImage_one from "../../assets/hero-bg/HomeImage1.png";
import HomeImage_two from "../../assets/hero-bg/HomeImage2.png";
import HomeImage_three from "../../assets/hero-bg/HomeImage3.png";
import judithPhoto from "../../assets/judith-photo.png";


export default function Home() {
  const navigate = useNavigate();

  const handleProjectClick = (projectKey) => {
    navigate(`/projects?project=${projectKey}`);
  };

  const projects = [
    {
      key: "flowOptimization",
      title: "Flow optimization",
      subtitle: "Product designer at BBVA Mexico",
      image: HomeImage_one,
      hoverColor: "#D3CCFF"
    },
    {
      key: "designSystem",
      title: "Design System",
      subtitle: "UX/UI Designer at Todo1 Colombia (Now Iuvity)",
      image: HomeImage_two,
      hoverColor: "#AACCFF"
    },
    {
      key: "art",
      title: "Art",
      subtitle: "Personal artwork",
      image: HomeImage_three,
      hoverColor: "#FFCB8F"
    }
  ];

  const tags = ["Digital banking", "User Research", "UX/UI Design", "Interactive media"];

  return (
    <div className="home">
      {/* Hero Section - Two columns */}
      <section className="home__hero">
        {/* Left Column - Intro */}
        <div className="home__intro">
          <span className="home__asterisk">✳</span>
          
          <h1 className="home__title">
            <h3>Engineer and Product Designer with experience in creating digital products for the financial sector</h3>
          </h1>
          
          <p className="home__description">
            My work centers on purposeful and ethical design, with a strong interest in accessibility as a way to reduce barriers to information, technology, and financial services. I aim to create inclusive solutions that bring people closer to the resources they need.
          </p>

          <div className="home__tags">
            {tags.map((tag, index) => (
              <span key={index} className="home__tag">{tag}</span>
            ))}
          </div>
        </div>

        {/* Right Column - Project Cards */}
        <div className="home__projects">
          {projects.map((project) => (
            <ProjectCard
              key={project.key}
              title={project.title}
              subtitle={project.subtitle}
              image={project.image}
              hoverColor={project.hoverColor}
              projectKey={project.key}
              onClick={handleProjectClick}
            />
          ))}
        </div>
      </section>

      {/* About Section */}
      <section className="home__about">
        <div className="home__about-card">
          <div className="home__about-photo">
             <img src={judithPhoto} alt="Judith Matute" /> 
            <div className="home__about-photo-placeholder" />
        
          </div>
          
          <div className="home__about-content">
            <h2 className="home__about-title">Hello! I am Judith</h2>
            <p className="home__about-text">
              I studied Engineering in digital Entertainment Design at Universidad Pontificia Bolivariana, now working as product designer at BBVA Mexico, by Multiplica Talent. I am peruvian, living in Riohacha La Guajira in Colombia.
            </p>
            <button 
              className="home__about-button"
              onClick={() => navigate('/about')}
            >
              About me
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}